import Vue from 'vue'
import VueRouter from 'vue-router'
import indexC from '../views/indexView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: indexC,
    meta: {
      reload: true,
    },
  },
/* 
  {
    path: '/login',
    name: 'loginV',
    component: () => import('../views/loginView.vue'),
    meta: {
      reload: true,
    },
  
  },
 */
//   {
//     path: '/inicio',
//     name: 'inicioV',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import('../views/inicioView.vue')
//   },
//   {
//     path: '/acumulaciones',
//     name: 'acumulacionesV',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import('../views/acumulacionesView.vue')
//   },
//   {
//     path: '/canjes',
//     name: 'canjesV',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import('../views/canjesView.vue')
//   },
//   {
//     path: '/facturas',
//     name: 'facturasV',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import('../views/facturasView.vue')
//   },
//   {
//     path: '/canjearPuntos',
//     name: 'canjearPuntosV',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import('../views/canjearPuntosView.vue')
//   },
// {

//     path: '/canjesGasolinaV',
//     name: 'canjesGasolinaV',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import('../views/canjesGasolinaView.vue')
//   },
//   {
//     path: '/compartirQR',
//     name: 'compartirQRV',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import('../views/compartirQRView.vue')
//   },

]

const router = new VueRouter({
  mode:'',
  routes
})

export default router
